import {PermissionCollection} from "../../collections/Permissions";

export interface BaseDashboardCategoryLayoutOptions {
    permissionCollection: PermissionCollection;
    model: Backbone.Model;
    $el: JQuery;
}

export abstract class BaseDashboardCategoryLayout {

    constructor(protected options: BaseDashboardCategoryLayoutOptions) {
    };

    abstract initialize(): void;

    abstract layout(viewsAddedOrRemoved?: boolean): void;

    abstract remove(): void;

    abstract isInitialized(): boolean;
}


// WEBPACK FOOTER //
// ./srv/public/js/views/dashboard/_BaseDashboardCategoryLayout.ts